// extracted by mini-css-extract-plugin
export default {"sign-up":"SignIn_sign-up__i1OW1","center-box":"SignIn_center-box__0xI4h"};